import moment from "moment";
import "moment/locale/es";

// Convención de semanas del módulo de producción: la numeración es la de ISO
// 8601, la misma del backend (api/utils/produccion_v2/semanas.py), pero la
// semana va de sábado a viernes y no de lunes a domingo. Equivale a correr la
// semana ISO dos días hacia atrás: la semana 34 de 2026 va del sábado 15/08 al
// viernes 21/08, no del lunes 17/08 al domingo 23/08.
//
// El número y el año siguen saliendo de ISO, así que la semana que cruza el
// cambio de año no se parte y el año sigue teniendo 52 o 53 semanas. Este
// archivo es el único que calcula semanas: el resto del módulo solo consume las
// funciones de abajo.

// La semana de sábado a viernes empieza dos días antes que su semana ISO
const DIAS_ANTES_DEL_LUNES_ISO = 2;

// Locale de moment para que los calendarios del módulo arranquen en domingo, que
// es como se leen; se pasa a los DatePicker con la prop locale. Es solo la
// presentación del calendario: la semana del módulo sigue yendo de sábado a
// viernes y sale de las funciones de abajo, no del week() de moment. Se define
// aparte para no mover el locale global, que usa el resto del sistema.
export const LOCALE_CALENDARIO_DOMINGO = "es-calendario-domingo";

const localeGlobal = moment.locale();

moment.defineLocale(LOCALE_CALENDARIO_DOMINGO, {
    parentLocale: "es",
    week: { dow: 0, doy: 6 },
});

// defineLocale deja como global el locale recién definido, hay que devolver el
// que estaba
moment.locale(localeGlobal);

// Semana y año a los que pertenece una fecha; sin argumento, los de hoy. Los dos
// valores tienen que salir del mismo calendario: con year() en vez de
// isoWeekYear(), un registro del 30/12/2025 queda guardado en la semana 1 de
// 2025, que es una semana de un año atrás.
export const getWeekOfDate = (date) => {
    const fecha = date ? moment(date) : moment();

    // el sábado y el domingo ya son de la semana siguiente, así que el número
    // sale de la fecha corrida hasta la semana ISO que le corresponde
    fecha.add(DIAS_ANTES_DEL_LUNES_ISO, "days");

    return {
        semana: fecha.isoWeek(),
        anio: fecha.isoWeekYear(),
    };
};

// Sábado y viernes de una semana. El año se fija con isoWeekYear para que el
// rango sea siempre el mismo, sin importar en qué fecha se abra la pantalla.
export const getWeekRange = (week, year) => {
    const start = moment()
        .isoWeekYear(year)
        .isoWeek(week)
        .startOf("isoWeek")
        .subtract(DIAS_ANTES_DEL_LUNES_ISO, "days");

    const end = start.clone().add(6, "days").endOf("day");

    return {
        start: start.toDate(),
        end: end.toDate(),
    };
};

export const getWeeksInYear = (year) => {
    return moment(`${year}-12-31`).isoWeeksInYear();
};
